import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Twitter, Linkedin } from "lucide-react";
import { BUSINESS, PRODUCTS } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-brand-forest text-brand-bone overflow-hidden grain">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 pt-20 pb-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="font-display text-3xl leading-tight">{BUSINESS.name}</h3>
            <p className="mt-3 text-brand-bone/60 max-w-sm leading-relaxed">
              {BUSINESS.tagline}. Fresh, quality-graded produce from Karnavati Market Yard, Ahmedabad.
            </p>
            <div className="flex gap-3 mt-8">
              {[Instagram, Facebook, Twitter, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  aria-label="social link"
                  className="h-11 w-11 rounded-full border border-brand-bone/20 flex items-center justify-center hover:bg-brand-leaf hover:border-brand-leaf transition-colors duration-300"
                >
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-bone/50">Explore</span>
            <ul className="mt-5 space-y-3">
              {[["Home", "/"], ["About", "/about"], ["Products", "/products"], ["Services", "/services"], ["Contact", "/contact"]].map(
                ([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-brand-bone/75 hover:text-white transition-colors duration-300">
                      {label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-4">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-bone/50">Get in touch</span>
            <ul className="mt-5 space-y-4 text-brand-bone/75">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 text-brand-leaf-light shrink-0" />
                <span>{BUSINESS.location}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-brand-leaf-light shrink-0" />
                <span className="flex flex-col">
                  <a href={`tel:${BUSINESS.phoneRaw}`} className="hover:text-white transition-colors">{BUSINESS.phone}</a>
                  <a href={`tel:${BUSINESS.phone2Raw}`} className="hover:text-white transition-colors">{BUSINESS.phone2}</a>
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-brand-leaf-light shrink-0" />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-white transition-colors break-all">{BUSINESS.email}</a>
              </li>
            </ul>
            <div className="mt-6 text-sm text-brand-bone/50 font-mono uppercase tracking-wide">
              We deal in: {PRODUCTS.map((p) => p.name.replace("Fresh ", "")).join(" · ")}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-10 border-t border-brand-bone/10">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-bone/50 mb-6 block">Our Group of Companies</span>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-display text-xl text-brand-leaf-light">Kishan Hiralal Prajapati</h4>
              <p className="mt-2 text-brand-bone/75 text-sm leading-relaxed max-w-sm">
                H-154, Karnavati Agriculture Market Yard,<br/>Ropda Circle, Vatva Ring road,<br/>Ahmedabad-382445
              </p>
            </div>
            <div>
              <h4 className="font-display text-xl text-brand-leaf-light">Hiralal Gelaji Prajapati</h4>
              <p className="mt-2 text-brand-bone/75 text-sm leading-relaxed max-w-sm">
                Shop No 96, Sardar Patel Market Yard,<br/>Gate no 1, Opp. Fire Station, Jamalpur,<br/>Ahmedabad-380022
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-bone/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-brand-bone/50">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
          <span className="font-mono">Karnavati Agriculture Market Yard · Vatva · Ahmedabad</span>
        </div>
      </div>

      <div className="select-none pointer-events-none">
        <div className="font-display text-[18vw] leading-none text-brand-bone/[0.04] text-center whitespace-nowrap">
          PRAJAPATI
        </div>
      </div>
    </footer>
  );
}
